import { fetchPromptBase } from "~/js/network/airtable-prompt-base";
import { setErrorScreen } from "~/js/utilities/setErrorScreen";
import { openPricingPage } from "~/solidJs/shared/models/pageParams/pricingPageParams";
import { mergeMlBase } from "./js/network/mergeMlBase";
import EventAnalytics, { setUserGroup } from "./js/utilities/EventAnalytics";
import { getWorkspaceIdFromPath } from "./solidJs/shared";
import { sessionCounter } from "./solidJs/shared/helpers/sessionCounter";
import {
	isInitTemplateGlobalHidden,
	isModalsGlobalHidden
} from "./solidJs/shared/helpers/testHelpers";
import { setIsAproveLeaveVisible } from "./solidJs/shared/models/globalStores";
export const isNeedToShowGreetings = () => {
	if (isModalsGlobalHidden()) return false;
	if (getWorkspaceIdFromPath(window.location.pathname)) return false;
	if (getWorkspaceIdFromPath(window.location.pathname, "template")) return false;
	if (getWorkspaceIdFromPath(window.location.pathname, "user-workspace")) return false;
	if (window.location.pathname === "/pricing") {
		openPricingPage({ source: "pricingPage" });
		return false;
	}
	const urlParams = new URLSearchParams(window.location.search);
	const nodeToAdd = urlParams.get("nodeToAdd");
	if (nodeToAdd) {
		return false;
	}
	const isSkiped = localStorage.getItem("skipGreetings") === "true";
	if (isSkiped) return false;
	return true;
};

window.addEventListener(
	"contextmenu",
	(event) => {
		event.preventDefault();
	},
	false
);
const addOnboardingNode = async () => {
	// const helpers = await import("~/solidJs/shared/helpers/nodeHelpers");
	// const editor = await import("~/js/editor");
	// editor.default.context.graph.navigation.setZoomScale(0.6);
	// helpers.addRemoteNodeByGlobalId({
	// 	globalId: "Phygital Creator/phygc-rnd-comfy-sdxl-text2img",
	// 	isStylesShowable: true
	// });
};

const showOnboarding = () => {
	if (!isInitTemplateGlobalHidden() && sessionCounter.getCurSessionCount() <= 3) {
		addOnboardingNode();
		return;
	}
};

/**
 * entry point of the graph editor, performs fetches, prepearing data, initializes the graph editor, mounts the editor
 */
function launch() {
	console.log(
		"%cLaunching...",
		"background: #000; color: #ffffff; font-weight: 700; padding: 3px"
	);

	localStorage.removeItem("history");

	setUserGroup();
	startAsync()
		.then(async () => {
			console.log(
				"%cPhygital Plus is ready!",
				"background: #37de12; color: #ffffff; font-weight: 700; padding: 3px"
			);
			setErrorScreen(false);
		})
		.catch((err) => {
			console.error(err);
			EventAnalytics.sendErrorInfo("err-start", {
				message: err.message
			});
			setErrorScreen(true);
			relaunch();
		});
}

function relaunch() {
	startAsync()
		.then(() => {
			console.log(
				"%cPhygital Plus is ready!",
				"background: #37de12; color: #ffffff; font-weight: 700; padding: 3px"
			);
			setErrorScreen(false);
		})
		.catch((err) => {
			console.log(err);
			console.log(
				"%cUps, smth wrong... Restart!",
				"background: #eb5307; color: #ffffff; font-weight: 700; padding: 3px"
			);
			setTimeout(() => {
				relaunch();
			}, 2000);
		});
}

/**
 * asyncronously imports required modules for graph functionality
 * @description main index module need to be as light as possible, so we code split the editor code containing all the packages and logic for graph app
 */
async function requiredDynamicImports() {
	const Editor = import("./js/editor");
	await Promise.allSettled([Editor]);
	return {
		Editor: await Editor
	};
}

async function startAsync() {
	// we need to merge ml base before int the graph
	const promisesToAwait = [mergeMlBase(), requiredDynamicImports()] as const;
	try {
		sessionCounter.increaseSessionCount();
	} catch (e) {
		console.log(e);
		throw e;
	}

	const awaitedPromises = await Promise.allSettled(promisesToAwait);
	const graphPromise = awaitedPromises[1];
	if (graphPromise.status === "rejected") {
		throw graphPromise.reason;
	}
	const graphModule = graphPromise.value;
	await graphModule.Editor.default.createNewGraph();
	await graphModule.Editor.default.setCheckBeforeUnload();

	try {
		showOnboarding();
		fetchPromptBase();
	} catch (err) {
		console.error(err);
	}
}

export function showLeaveWorkspaceModal(callback = () => window.location.reload()) {
	setIsAproveLeaveVisible({ callback });
}

export default launch;
